/* eslint-disable camelcase */
import { Controller } from '@hotwired/stimulus'

import { trackSegment } from '../utils/track'

export default class HomepageScrollController extends Controller {
  static targets = ['stickyHeader', 'floatingFilterButton']

  fired = false

  trackFirstAppearance() {
    // TODO: Ask for prop values needed for this event
    trackSegment('Static Component Event', {
      component_id: 'sticky-header',
      component_name: 'QLJ Prompt',
      event_name: 'viewed'
    })

    this.fired = true
  }

  connect() {
    this.onScroll()
  }

  shouldShow() {
    return (
      document.documentElement.scrollTop > this.bottomOfFirstDealCard &&
      document.documentElement.scrollTop < this.bottomOfDealTable
    )
  }

  onScroll() {
    const firstDealCard = document.querySelector('.dealcard').getBoundingClientRect()
    const dealTable = document.getElementById('table').getBoundingClientRect()
    const scrollTop = document.documentElement.scrollTop

    this.bottomOfFirstDealCard = firstDealCard.top + scrollTop + firstDealCard.height
    this.bottomOfDealTable = dealTable.top + scrollTop + dealTable.height

    if (this.hasFloatingFilterButtonTarget) {
      this.floatingFilterButtonTarget.setAttribute('data-hidden', !this.shouldShow())
    }

    if (this.shouldShow()) {
      if (!this.fired) {
        this.trackFirstAppearance()
      }

      this.stickyHeaderTarget.style.transform = 'translateY(0)'
    } else {
      this.stickyHeaderTarget.style.transform = 'translateY(-100%)'
    }
  }
}
